module.exports = __webpack_public_path__ + "static/media/FGNXALAT_logo.f500b400.png";